module.exports = __webpack_public_path__ + "static/yorwarth-icon-8151e4dd818d0b0367b2b036af851760.svg";